/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { AccessKeysContext } from "../context/AccessKeysContext"
import React, { Component } from "react"
import { Col, Form, FormGroup } from "react-bootstrap"
import { Field as FinalFormField } from "react-final-form"

export default class NumberField extends Component {
  render() {
    return (
      <AccessKeysContext.Consumer>
        {(accessKeys = {}) => {
          const { name } = this.props
          const ak = accessKeys[name] || {}
          const {
            hidden,
            placeholder,
            inputmode,
            label,
            className,
            xs,
            lg,
            xl,
            md,
            sm,
            xsHidden,
            smHidden,
            mdHidden,
            lgHidden,
            xlHidden,
            hasServerErrors,
            noFormGroup,
            initialValue,
            type = "number",
            trimOnBlur,
            addCbSeparator,
            addIbanSeparator,
            onKeyDown,
            children
          } = { ...this.props, ...ak }

          // `accessKeys` peut forcer `disabled` en UAT. Ici on fait primer le contrôle métier
          // (prop `disabled` explicite) sur l'override d'accessKeys.
          const disabled = this.props.disabled !== undefined ? this.props.disabled : ak.disabled

          if (hidden) {
            return false
          }
          let trimOnBlurProps = null
          if (trimOnBlur === true) {
            trimOnBlurProps = {
              formatOnBlur: true,
              format: this.trimValue
            }
          }
          let addCbSeparatorProps = null
          if (addCbSeparator === true) {
            addCbSeparatorProps = {
              onKeyUp: this.addCbSeparator
            }
          }
          let addIbanSeparatorProps = null
          if (addIbanSeparator === true) {
            addIbanSeparatorProps = {
              onKeyUp: this.addIbanSeparator
            }
          }

          return (
            <FinalFormField
              name={name}
              component="input"
              type={type}
              placeholder={placeholder}
              className="form-control"
              initialValue={initialValue}
              {...trimOnBlurProps}
            >
              {({ input, meta }) => {
                const metaError = meta.error && (meta.touched || hasServerErrors)
                const hasError = metaError || meta.submitError
                const cl = {
                  "d-none": xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
                  "d-sm-block": !smHidden,
                  "d-sm-none": smHidden,
                  "d-md-block": !mdHidden,
                  "d-md-none": mdHidden,
                  "d-lg-block": !lgHidden,
                  "d-lg-none": lgHidden,
                  "d-xl-block": !xlHidden,
                  "d-xl-none": xlHidden,
                  "col-no-padding": true
                }
                if (className) {
                  cl[className] = true
                }
                const hasColParam =
                  xs || lg || xl || md || sm || xsHidden || smHidden || mdHidden || lgHidden || xlHidden
                const colParams = { className: cl, xs, lg, xl, md, sm }

                let body = [
                  <div className="d-flex" key={label}>
                    {label && <Form.Label>{label}</Form.Label>}
                    {children}
                  </div>,
                  <Form.Control
                    id={name}
                    key="input"
                    autoComplete="off"
                    inputMode={inputmode ? inputmode : null}
                    {...input}
                    className={hasError && "textfield-error"}
                    type="number"
                    placeholder={placeholder}
                    onChange={(e) => e.target.value >= 0 && input.onChange(e.target.value)}
                    disabled={disabled}
                    onKeyDown={onKeyDown}
                    {...addCbSeparatorProps}
                    {...addIbanSeparatorProps}
                  />,
                  <React.Fragment key="alert">
                    {hasError && <p className="required-message">{meta.error || meta.submitError}</p>}
                  </React.Fragment>
                ]

                if (!noFormGroup) {
                  body = <FormGroup>{body}</FormGroup>
                }

                if (hasColParam) {
                  body = <Col {...colParams}>{body}</Col>
                }

                return body
              }}
            </FinalFormField>
          )
        }}
      </AccessKeysContext.Consumer>
    )
  }

  trimValue(value) {
    return value ? value.trim() : null
  }

  addCbSeparator(event) {
    if (event.key !== "Backspace") {
      let formattedChain = event.currentTarget.value?.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")
      event.currentTarget.value = formattedChain
    }
  }

  addIbanSeparator(event) {
    if (typeof event.key === "string") {
      let formattedChain = event.currentTarget.value?.toUpperCase()
      event.currentTarget.value = formattedChain
    }
    if (event.key !== "Backspace") {
      let formattedChain = event.currentTarget.value?.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")
      event.currentTarget.value = formattedChain
    }
  }
}
